module.exports = __webpack_public_path__ + "static/media/3_Point_Soft_Overhead.4ea3fb76.png";